module.exports = __webpack_public_path__ + "static/img/08_pro.477314f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/08_pro.jpg
// module id = Kf19
// module chunks = 0